var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "rotate(-12 18 18)",
    d: "M10 4H26C29.3137 4 32 6.68629 32 10V26C32 29.3137 29.3137 32 26 32H10C6.68629 32 4 29.3137 4 26V10C4 6.68629 6.68629 4 10 4ZM7.9 10.5C7.9 11.936 9.064 13.1 10.5 13.1C11.936 13.1 13.1 11.936 13.1 10.5C13.1 9.064 11.936 7.9 10.5 7.9C9.064 7.9 7.9 9.064 7.9 10.5ZM22.9 10.5C22.9 11.936 24.064 13.1 25.5 13.1C26.936 13.1 28.1 11.936 28.1 10.5C28.1 9.064 26.936 7.9 25.5 7.9C24.064 7.9 22.9 9.064 22.9 10.5ZM15.4 18C15.4 19.436 16.564 20.6 18 20.6C19.436 20.6 20.6 19.436 20.6 18C20.6 16.564 19.436 15.4 18 15.4C16.564 15.4 15.4 16.564 15.4 18ZM7.9 25.5C7.9 26.936 9.064 28.1 10.5 28.1C11.936 28.1 13.1 26.936 13.1 25.5C13.1 24.064 11.936 22.9 10.5 22.9C9.064 22.9 7.9 24.064 7.9 25.5ZM22.9 25.5C22.9 26.936 24.064 28.1 25.5 28.1C26.936 28.1 28.1 26.936 28.1 25.5C28.1 24.064 26.936 22.9 25.5 22.9C24.064 22.9 22.9 24.064 22.9 25.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.b4e09d6d12d3fce6a0ff929719b38941.svg";
export { ForwardRef as ReactComponent };